import {Component} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {AnnualSchoolProfileService} from "../services/annual-school-profile.service";
import {AnnualSchoolProfile} from "../interfaces/annual-school-profile";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {TeacherService} from "../services/teacher.service";
import {Teacher} from "../interfaces/teacher";
import {ProjectService} from "../services/project.service";
import {Project} from "../interfaces/project";
import {SearchResultTableComponent} from "./table/search-result-table.component";

@Component({
  selector: 'app-dashboard-search-result',
  templateUrl: './dashboard-search-result.component.html',
  standalone: true,
  imports: [
    CommonModule, FormsModule, SearchResultTableComponent,
  ],
  styleUrl: './dashboard-search-result.component.css'
})
export class DashboardSearchResultComponent {
  constructor(private route: ActivatedRoute, private annualProfileService: AnnualSchoolProfileService,
              private teacherService: TeacherService,
              private projectService: ProjectService) {
  }

  query = '';
  annualProfile: AnnualSchoolProfile[] = [];
  filteredProfile: AnnualSchoolProfile[] = [];
  teachers: Teacher[] = [];
  filteredTeachers: Teacher[] = [];
  project: Project[] = [];
  filteredProject: Project[] = [];
  isDownloaded: boolean = false;

  async ngOnInit() {
    this.annualProfile = await this.annualProfileService.getProfiles();
    this.teachers = await this.teacherService.getTeachersByRole() ?? [];
    this.project = await this.projectService.getProjects();

    this.route.queryParams.subscribe(params => {
      this.query = params['q'] || '';
      this.filterSearch(this.query);
    });
  }

  filterSearch(query: string) {
    if (!query) {
      this.filteredProfile = [...this.annualProfile];
      this.filteredTeachers = [...this.teachers];
      this.filteredProject = [...this.project];
      this.isDownloaded = false;
      return;
    }

    const words = query.toLowerCase().split(/\s+/);

    this.filteredProfile = this.annualProfile.filter(profile =>
      words.some(word =>
        Object.values(profile).some(val =>
          val.toString().toLowerCase().includes(word)
        )
      )
    );

    this.filteredTeachers = this.teachers.filter(teacher =>
      words.some(word =>
        Object.values(teacher).some(val =>
          val != null && val.toString().toLowerCase().includes(word)
        )
      )
    );

    this.filteredProject = this.project.filter(project =>
      words.some(word =>
        Object.values(project).some(val =>
          val != null && val.toString().toLowerCase().includes(word)
        )
      )
    );
    this.isDownloaded = true;
  }

  pageSize = 10;
  currentPageProfile = 1;
  currentPageTeachers = 1;
  currentPageProject = 1;

  teacherColumns = [
    { header: 'Role', field: 'role' },
    { header: 'First Name', field: 'fName' },
    { header: 'Last Name', field: 'lName' },
    { header: 'Email', field: 'email' },
    { header: 'School', field: 'school' },
    { header: 'Grade', field: 'grade' },
  ];

  projectColumns = [
    { header: 'Date', field: 'schoolYear' },
    { header: 'Project Title', field: 'title' },
    { header: 'Rep Name', field: 'representativeName' },
    { header: 'Rep Email', field: 'representativeEmail' },
    { header: 'Description', field: 'projectDesc' },
  ];

  profileColumns = [
    { header: 'Year', field: 'schoolYear' },
    { header: 'School Name', field: 'school' },
    { header: 'GHS Rep Name', field: 'ghsRepresentativeName' },
    { header: 'GHS Rep Email', field: 'ghsRepresentativeEmail' },
    { header: 'Teachers', field: 'numOfTeacherAndStaff' },
    { header: 'Students', field: 'numOfStudents' },
  ];

  protected readonly Math = Math;
}
